var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormFrame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 552,
    height: 699,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    width: 522,
    height: 593,
    rx: 20,
    fill: "#1A1353"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 524,
    y: 696,
    width: 521,
    height: 584.393,
    rx: 13,
    transform: "rotate(-180 524 696)",
    stroke: "#00AECF",
    strokeWidth: 6
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTUyIiBoZWlnaHQ9IjY5OSIgdmlld0JveD0iMCAwIDU1MiA2OTkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjMwIiB3aWR0aD0iNTIyIiBoZWlnaHQ9IjU5MyIgcng9IjIwIiBmaWxsPSIjMUExMzUzIi8+CjxyZWN0IHg9IjUyNCIgeT0iNjk2IiB3aWR0aD0iNTIxIiBoZWlnaHQ9IjU4NC4zOTMiIHJ4PSIxMyIgdHJhbnNmb3JtPSJyb3RhdGUoLTE4MCA1MjQgNjk2KSIgc3Ryb2tlPSIjMDBBRUNGIiBzdHJva2Utd2lkdGg9IjYiLz4KPC9zdmc+Cg==";
export { SvgFormFrame as ReactComponent };